import { Stack, styled } from "@mui/material";
import { HtmlViewer, TextMd } from "Components";
import { useItemContext } from "..";
import { useIntl } from "react-intl";

type Props = {};

const ItemDescription = (props: Props) => {
  const { data } = useItemContext();
  const intl = useIntl();

  if (!data?.farm_item_description) return null;

  return (
    <StyledItemDescription>
      <TextMd component="h2">
        {intl.formatMessage({ id: "product_desc_from_supplier" })}
      </TextMd>

      <HtmlViewer
        content={data?.farm_item_description}
        className="description"
      />
    </StyledItemDescription>
  );
};

const StyledItemDescription = styled(Stack)({
  width: "100%",
  ".title": {
    fontSize: 16,
    fontWeight: 700,
  },
  ".description": {
    fontSize: 14,
  },
});

export default ItemDescription;
